import { uuidv7 } from 'uuidv7';
import * as z from 'zod';
import { zql } from '../../schema.js';
import { itemsDetail, valueItem } from '../../util/event-log-items.js';
import { EventLogs } from '../../util/event_logs.js';
import { addEventLog, EventLogResources } from '../util.js';
/** A soft dose limit warning the prescriber read and proceeded past, as the dose check reported it. */
export const DoseLimitConfirmation = z.object({
    activeSubstanceId: z.string(),
    limit: z.number(),
    unit: z.string(),
    level: z.string(),
});
export function doseLimitItems(params) {
    return [
        { field: 'dose', label: params.name, value: params.totalAmount ?? null, unit: params.unit },
        { field: 'limit', value: params.limit, unit: params.unit },
        ...valueItem('limit_level', params.level, { valueKey: 'event.value.limit_level.{value}' }),
    ];
}
/** One PRESCRIPTION_DOSE_LIMIT_CONFIRMED log per saved medicine whose dose limit warning was confirmed. Server only. */
export async function logDoseLimitConfirmations(tx, params) {
    if (tx.location !== 'server' || !params.confirmed?.length)
        return;
    await Promise.all(params.confirmed.flatMap(confirmation => {
        const medicine = params.medicines.find(m => m.activeSubstanceId === confirmation.activeSubstanceId);
        if (!medicine)
            return [];
        return [
            (async () => {
                const drug = await tx.run(zql.drugCatalogItems.where('id', '=', confirmation.activeSubstanceId).one());
                await addEventLog(tx, {
                    id: uuidv7(),
                    resource: EventLogResources.patientTherapySequenceMedicine,
                    resourceId: medicine.id,
                    action: 'create',
                    domain: 'prescription',
                    event: EventLogs.PRESCRIPTION_DOSE_LIMIT_CONFIRMED,
                    status: 'WARNING',
                    performedBy: params.userId,
                    performedAt: params.now,
                    details: {
                        therapyInternalId: params.therapyInternalId ?? '',
                        ...itemsDetail(doseLimitItems({ name: drug?.name ?? '-', totalAmount: medicine.totalAmount, ...confirmation })),
                    },
                });
            })(),
        ];
    }));
}
//# sourceMappingURL=dose-limit-log.js.map